import { render, staticRenderFns } from "./PopularGamesFilter.vue?vue&type=template&id=06521261&"
import script from "./PopularGamesFilter.vue?vue&type=script&lang=js&"
export * from "./PopularGamesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports